import z from "zod";

const OvulationSchema = z.object({
  lastPeriodStartDate: z.string(),
  previousPeriodStartDate: z.string(),
});

export type Ovulation = z.infer<typeof OvulationSchema>;

export interface Tool {
  id: number | string;
  title: string;
  slug: string;
  description: string;
  image: string;
}

export interface OvulationResponse {
  resultTitle: string;
  cycleLengthDays: number;
  cycleLengthSuffix: string;
  nextPeriodDate: string;
  nextPeriodDateText: string;
  ovulationDate: string;
  ovulationDateText: string;
  fertileWindowStartDate: string;
  fertileWindowStartDateText: string;
  fertileWindowEndDate: string;
  fertileWindowEndDateText: string;
  cycleSummaryText: string;
  fertilitySummaryText: string;
  warningText: string;
}

export const BirthDateSchema = z.object({
  mode: z.string({ error: "Bos Gecilemez" }),
  referenceDate: z
    .string({ error: "Bos Gecilemez" })
    .min(1, { message: "Bos Gecilemez" }),
});

export type BirthDateModel = z.infer<typeof BirthDateSchema>;

export interface BirthDateResponse {
  resultTitle: string;
  daysRemaining: number;
  countdownSuffix: string;
  isOverdue: boolean;
  dueDate: string;
  dueDateText: string;
  pregnancyWeek: number;
  pregnancyDayCount: number;
}

export const IdealWeightSchema = z.object({
  birthDate: z
    .string({ error: "Boş geçilemez" })
    .min(1, { message: "Doğum tarihi zorunludur" }),
  gender: z
    .string({ error: "Boş geçilemez" })
    .min(1, { message: "Cinsiyet zorunludur" }),
  heightCm: z
    .string({ error: "Boş geçilemez" })
    .min(1, { message: "Boy zorunludur" }),
  weightGram: z
    .string({ error: "Boş geçilemez" })
    .min(1, { message: "Kilo zorunludur" }),
});

export type IdealWeightModel = z.infer<typeof IdealWeightSchema>;

export interface IdealWeightResponse {
  resultTitle: string;
  babyAgeText: string;
  idealHeightRangeText: string;
  babyHeightText: string;
  idealWeightRangeText: string;
  babyWeightText: string;
  heightAssessmentText: string;
  weightAssessmentText: string;
}

export const BodyMassIndexSchema = z.object({
  heightCm: z
    .string({ error: "Boy zorunludur" })
    .min(1, { message: "Boy zorunludur" }),
  weightKg: z
    .string({ error: "Kilo zorunludur" })
    .min(1, { message: "Kilo zorunludur" }),
});

export type BodyMassIndexModel = z.infer<typeof BodyMassIndexSchema>;

export interface BodyMassIndexResponse {
  value: number;
  valueText: string;
  categoryLabel: string;
  categoryColor: string;
  description: string;
}

export const VaccineSchema = z.object({
  babyName: z
    .string({ error: "Bebek adı zorunludur" })
    .min(1, { message: "Bebek adı zorunludur" }),
  birthDate: z
    .string({ error: "Doğum tarihi zorunludur" })
    .min(1, { message: "Doğum tarihi zorunludur" }),
  gender: z.number(),
});

export type VaccineModel = z.infer<typeof VaccineSchema>;

export interface VaccineResponse {
  child: Child;
  vaccines: Vaccine[];
}

export interface Child {
  babyName: string;
  gender: number;
  birthDate: string;
}

export interface Vaccine {
  title: string;
  dateText: string;
  items: Item[];
}

export interface Item {
  date: string;
  dateText: string;
  name: string;
  description: string;
}
